import React from 'react';
import { Button, ButtonLoading } from '@trevor/ui-components';
import styled from 'styled-components';
import { unifiedStopPropagation } from '../../../../util/unifiedStopPropagation';
import { DropdownItem } from '../types';

export type DeleteConfirmationControlsProps = {
  onHideControls: () => void;
  item: DropdownItem;
};

const DeleteConfirmationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: var(--spacing-s);
`;

const DeleteButtonContainer = styled.div`
  width: 110px;
`;

export const DeleteConfirmationControls: React.FC<
  DeleteConfirmationControlsProps
> = ({ onHideControls, item }) => {
  const handleCancel = (e: React.MouseEvent) => {
    unifiedStopPropagation(e);
    onHideControls();
  };

  const handleAction = (e: React.MouseEvent) => {
    item.onAction(e);
    onHideControls();
  };

  const isDeleting = item.isLoading && item.isLoading();

  return (
    <DeleteConfirmationContainer>
      <Button variant="secondary" size="small" onClick={handleCancel}>
        Cancel
      </Button>
      <DeleteButtonContainer>
        <ButtonLoading
          loading={isDeleting}
          size="small"
          variant="danger"
          expanded
          onClick={handleAction}
        >
          Confirm delete
        </ButtonLoading>
      </DeleteButtonContainer>
    </DeleteConfirmationContainer>
  );
};
